import { useMemo } from 'react';

import styles from './styles.module.scss';
import { DocumentStatusEnum } from '../../../../common/document/enums/document-status.enum';
import { IDriverDocument } from '../../../../common/document/interfaces/driver-document';

type InputProps = {
  document: IDriverDocument;
};

export enum DocumentRejectionReasonEnum {
  BLURRY = 'BLURRY',
  INCORRECT_DOCUMENT = 'INCORRECT_DOCUMENT',
  EXPIRED = 'EXPIRED',
  OTHER = 'OTHER',
}

export const rejectionReasonMapping: { [key: string]: string } = {
  [DocumentRejectionReasonEnum.BLURRY]: 'Image Blurry',
  [DocumentRejectionReasonEnum.INCORRECT_DOCUMENT]: 'Incorrect Document',
  [DocumentRejectionReasonEnum.EXPIRED]: 'Expired',
  [DocumentRejectionReasonEnum.OTHER]: 'Other',
};

export const DocumentStatusText = ({ document }: InputProps) => {
  const { statusText, color } = useMemo(() => {
    switch (document.status) {
      case DocumentStatusEnum.PARTIALLY_UPLOADED:
      case DocumentStatusEnum.REQUESTED:
        return {
          statusText: document.rejectionReason
            ? document.rejectionReason
            : 'Please Upload',
          color: '#7A858D',
        };
      case DocumentStatusEnum.REJECTED:
        if (document.rejectionReason === DocumentRejectionReasonEnum.OTHER) {
          return {
            statusText: 'Please Re-Upload',
            color: '#D61818',
          };
        }
        return {
          statusText: `${
            rejectionReasonMapping[document.rejectionReason as string] ||
            document.rejectionReason
          }. Please Re-Upload`,
          color: '#D61818',
        };
      case DocumentStatusEnum.NEEDS_REVIEW:
      case DocumentStatusEnum.UPLOADED:
        return {
          statusText: 'Submitted',
          color: '#35C7FF',
        };
      default:
        return {
          statusText: 'Approved',
          color: '#7A858D',
        };
    }
  }, [document.status]);

  return (
    <div className={styles.statusText}>
      <span style={{ color }}>{statusText}</span>
    </div>
  );
};
